module.exports = __webpack_public_path__ + "img/idriss_n.c9e8529a.png";